export default __webpack_public_path__ + "static/media/promo-banner-11-11.95ec393a.svg";